import { $ } from "@/common/Axios";

export default {
  /**
   * 角色菜单
   */
  positionMenu_updatePermission: {
    /*
     * 编辑权限
     * platform 平台 (string query required)
     * position 职位 (string query required)
     * menuIds 权限id (array query required)
     */
    put: (p, c) => $.put("/api/bms/system/positionMenu/updatePermission", p, c),
  },
  positionMenu_manage: {
    /*
     * 权限
     * employStatus 是否内部 (string query required)
     * position 职位 (string query required)
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/positionMenu/manage", p, c),
  },
  positionMenu_listOut: {
    /*
     * 外部职位列表
     */
    get: (p, c) => $.get("/api/bms/system/positionMenu/listOut", p, c),
  },
  positionMenu_listInner: {
    /*
     * 内部职位列表
     */
    get: (p, c) => $.get("/api/bms/system/positionMenu/listInner", p, c),
  },

  /**
   * 菜单
   */
  menu_refreshRedis: {
    /*
     * 刷新缓存
     */
    put: (p, c) => $.put("/api/bms/system/menu/refreshRedis", p, c),
  },
  menu: {
    /*
     * 添加|编辑
     * menu  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/menu", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/system/menu", p, c),
  },
  menu_able: {
    /*
     * 启用禁用
     * id id (integer query required)
     * ableStatus 启用禁用 (string query required)
     */
    post: (p, c) => $.post("/api/bms/system/menu/able", p, c),
  },
  menu_listPlatform: {
    /*
     * 平台列表
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/menu/listPlatform", p, c),
  },
  menu_listMenu: {
    /*
     * 菜单列表（树型结构）(到菜单为止)
     * platform 平台 (string query required)
     * ableStatus 启用禁用 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/menu/listMenu", p, c),
  },
  menu_listMenuByPosition: {
    /*
     * 菜单列表（树型结构）(到菜单这个级别为止)（根据角色）
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/menu/listMenuByPosition", p, c),
  },
  menu_listMenuByParent: {
    /*
     * 根据父目录获取菜单列表
     * parentId 父目录id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/menu/listMenuByParent", p, c),
  },
  menu_listDir: {
    /*
     * 目录列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/menu/listDir", p, c),
  },
  menu_listDirByPlatformAndParent: {
    /*
     * 根据平台和父目录获取目录列表
     * platform 平台 (string query required)
     * parentId 父目录id，0表示顶级目录 (integer query required)
     */
    get: (p, c) =>
      $.get("/api/bms/system/menu/listDirByPlatformAndParent", p, c),
  },
  menu_listButtonByPosition: {
    /*
     * 按钮列表（根据角色）
     * menuId 菜单id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/menu/listButtonByPosition", p, c),
  },
  menu_listButtonByMenu: {
    /*
     * 根据菜单获取按钮列表
     * menuId 菜单id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/menu/listButtonByMenu", p, c),
  },
  menu_listAllPlatform: {
    /*
     * 平台列表
     */
    get: (p, c) => $.get("/api/bms/system/menu/listAllPlatform", p, c),
  },

  /**
   * 脱敏导出
   */
  desensitizationExport_authorization: {
    /*
     * 授权
     * id id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/bms/system/desensitizationExport/authorization", p, c),
  },
  desensitizationExport: {
    /*
     * 添加
     * export  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/desensitizationExport", p, c),
  },
  desensitizationExport_details: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/desensitizationExport/details", p, c),
  },

  /**
   * 部门
   */
  department_updateAdmin: {
    /*
     * 编辑负责人
     * departmentId 部门id (integer query required)
     * adminIds 管理员id (array query required)
     */
    put: (p, c) => $.put("/api/bms/system/department/updateAdmin", p, c),
  },
  department: {
    /*
     * 添加
     * department  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/department", p, c),
  },
  department_uploadEnrollDept: {
    /*
     * 导入合同代报部门
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/bms/system/department/uploadEnrollDept", p, c),
  },
  department_setSalesGroup: {
    /*
     * 设置销售组别
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/department/setSalesGroup", p, c),
  },
  department_setEnrollDept: {
    /*
     * 设置合同代报部门
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/department/setEnrollDept", p, c),
  },
  department_saveSprintCampaignTeam: {
    /*
     * 添加作战部门
     * content 拼接好的Json (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/system/department/saveSprintCampaignTeam", p, c),
  },
  department_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/department/list", p, c),
  },
  department_listSubDepartment: {
    /*
     * 指定父级的直接下级部门列表, 只一层
     * parentId parentId (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/department/listSubDepartment", p, c),
  },
  department_listSprintCampaignTeam: {
    /*
     * 获取作战部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/system/department/listSprintCampaignTeam", p, c),
  },
  department_listSalesGroup: {
    /*
     * 销售组别列表
     */
    get: (p, c) => $.get("/api/bms/system/department/listSalesGroup", p, c),
  },
  department_listRIds: {
    /*
     * 递归获取下级部门id
     * id 部门id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/department/listRIds", p, c),
  },
  department_listRDepartments: {
    /*
     * 递归获取下级部门
     * id 部门id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/department/listRDepartments", p, c),
  },
  department_listPoint: {
    /*
     * 招生点列表
     */
    get: (p, c) => $.get("/api/bms/system/department/listPoint", p, c),
  },
  department_listFirstGrade: {
    /*
     * 一级部门列表
     */
    get: (p, c) => $.get("/api/bms/system/department/listFirstGrade", p, c),
  },
  department_listEnrollDept: {
    /*
     * 合同代报部门列表
     */
    get: (p, c) => $.get("/api/bms/system/department/listEnrollDept", p, c),
  },
  department_listDepartment: {
    /*
     * 部门列表
     * ableStatus 禁用启用 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/department/listDepartment", p, c),
  },
  department_listCurrentChargeSubDepartment: {
    /*
     * 当前负责部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/system/department/listCurrentChargeSubDepartment", p, c),
  },
  department_listChargeDepartment: {
    /*
     * 所负责部门列表
     */
    get: (p, c) =>
      $.get("/api/bms/system/department/listChargeDepartment", p, c),
  },
  department_listBusiness: {
    /*
     * 事业部级部门列表
     */
    get: (p, c) => $.get("/api/bms/system/department/listBusiness", p, c),
  },
  department_listAdmins: {
    /*
     * 部门负责人列表
     * departmentId 部门id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/department/listAdmins", p, c),
  },
  department_getEnrollDept: {
    /*
     * 获取合同代报部门
     */
    get: (p, c) => $.get("/api/bms/system/department/getEnrollDept", p, c),
  },
  department_exportEnrollDept: {
    /*
     * 导出合同代报部门
     */
    get: (p, c) => $.get("/api/bms/system/department/exportEnrollDept", p, c),
  },

  /**
   * 审批流
   */
  approvalFlow_changeAdmin: {
    /*
     * 审批流批量移交
     * originAdminId 审批流原来管理员 (integer query required)
     * adminId 新管理员 (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/approvalFlow/changeAdmin", p, c),
  },
  approvalFlow_withdrawApproval: {
    /*
     * 撤回审批
     * approvalId 审批实例id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/system/approvalFlow/withdrawApproval", p, c),
  },
  approvalFlow_repair: {
    /*
     * 修复approvalAdminLink
     * status 异动状态 (string query )
     * approvalId 审批实例id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/system/approvalFlow/repair", p, c),
  },
  approvalFlow_batchAuditApprovalFlow: {
    /*
     * 批量审核
     * flowIds 审批流id (array query required)
     * auditStatus 审核状态 (string query required)
     * comments 审批意见 (string query required)
     * periodDays 开发周期（需求开发技术审核） (number query )
     * accountType 账号类型（继教院不读合同负责人审核时） (string query )
     * accountNick 账号昵称（继教院不读合同负责人审核时） (string query )
     * account 账号（继教院不读合同负责人审核时） (string query )
     * amount 不读退款金额（继教院不读合同负责人审核时） (number query )
     */
    post: (p, c) =>
      $.post("/api/bms/system/approvalFlow/batchAuditApprovalFlow", p, c),
  },
  approvalFlow_auditApprovalFlow: {
    /*
     * 审批流审核，审批后返回整个审批的状态
     * flowId 审批流id (integer query required)
     * auditStatus 审核状态 (string query required)
     * comments 审批意见 (string query required)
     * attachmentUrl 审批附件 (string query )
     * periodDays 开发周期（需求开发技术审核） (number query )
     * accountType 账号类型（继教院不读合同负责人审核时） (string query )
     * accountNick 账号昵称（继教院不读合同负责人审核时） (string query )
     * account 账号（继教院不读合同负责人审核时） (string query )
     * amount 不读退款金额（继教院不读合同负责人审核时） (number query )
     */
    post: (p, c) =>
      $.post("/api/bms/system/approvalFlow/auditApprovalFlow", p, c),
  },
  approvalFlow_auditApprovalFlowIgnorePermission: {
    /*
     * 审批流审核，审批后返回整个审批的状态（忽略权限）
     * flowId 审批流id (integer query required)
     * auditStatus 审核状态 (string query required)
     * comments 审批意见 (string query required)
     * attachmentUrl 审批附件 (string query )
     * periodDays 开发周期（需求开发技术审核） (number query )
     * accountType 账号类型（继教院不读合同负责人审核时） (string query )
     * accountNick 账号昵称（继教院不读合同负责人审核时） (string query )
     * account 账号（继教院不读合同负责人审核时） (string query )
     * amount 不读退款金额（继教院不读合同负责人审核时） (number query )
     */
    post: (p, c) =>
      $.post(
        "/api/bms/system/approvalFlow/auditApprovalFlowIgnorePermission",
        p,
        c
      ),
  },
  approvalFlow_list: {
    /*
     * 列表
     * approvalId 审批id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/approvalFlow/list", p, c),
  },
  approvalFlow_listPage: {
    /*
     * 内部管理-审批列表
     */
    get: (p, c) => $.get("/api/bms/system/approvalFlow/listPage", p, c),
  },
  approvalFlow_listApprovalCategory: {
    /*
     * 审批类型列表
     */
    get: (p, c) =>
      $.get("/api/bms/system/approvalFlow/listApprovalCategory", p, c),
  },
  approvalFlow_details: {
    /*
     * 内部管理-审批列表-详情（基础的，具体的根据审批类型去不同业务端调用）
     * id 审批列表返回的ID (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/approvalFlow/details", p, c),
  },
  approvalFlow_removeApproval: {
    /*
     * 临时删除审批，异动失败的那种
     * approvalId 审批实例id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/system/approvalFlow/removeApproval", p, c),
  },

  /**
   * 审批配置
   */
  approvalConfig_sort: {
    /*
     * 排序
     * configsText 排序好的列表 (string query required)
     */
    put: (p, c) => $.put("/api/bms/system/approvalConfig/sort", p, c),
  },
  approvalConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/approvalConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/system/approvalConfig", p, c),
  },
  approvalConfig_copy: {
    /*
     * 复制
     * sourceName 源审批名 (string query required)
     * destName 目标审批名 (string query required)
     */
    post: (p, c) => $.post("/api/bms/system/approvalConfig/copy", p, c),
  },
  approvalConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/approvalConfig/list", p, c),
  },
  approvalConfig_listName: {
    /*
     * 审批名字列表
     */
    get: (p, c) => $.get("/api/bms/system/approvalConfig/listName", p, c),
  },
  approvalConfig_listByName: {
    /*
     * 根据名字获取配置列表
     * name 审批名字 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/approvalConfig/listByName", p, c),
  },

  /**
   * 管理员视图
   */
  adminView_sort: {
    /*
     * 排序
     * ids id (array query required)
     * sort 排序 (array query required)
     */
    put: (p, c) => $.put("/api/bms/system/adminView/sort", p, c),
  },
  adminView: {
    /*
     * 添加
     * adminView  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/adminView", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/system/adminView", p, c),
  },
  adminView_share: {
    /*
     * 分享
     * id id (integer query required)
     * adminIds 管理员id (array query required)
     */
    post: (p, c) => $.post("/api/bms/system/adminView/share", p, c),
  },
  adminView_list: {
    /*
     * 列表
     * menuId 菜单id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/adminView/list", p, c),
  },

  /**
   * 管理员蓝牙设备记录
   */
  adminBluetoothRecord_changeStatus: {
    /*
     * 修改设备状态
     * bluetoothDeviceId 设备id (string query required)
     * sort 排序 (string query required)
     * status 状态：正常、遗失、损坏 (string query required)
     */
    put: (p, c) =>
      $.put("/api/bms/system/adminBluetoothRecord/changeStatus", p, c),
  },
  adminBluetoothRecord: {
    /*
     * 添加
     * bluetoothDeviceId 设备id (string query required)
     * sort 排序 (string query required)
     * adminId 管理员id (integer query required)
     */
    post: (p, c) => $.post("/api/bms/system/adminBluetoothRecord", p, c),
  },
  adminBluetoothRecord_changeUser: {
    /*
     * 更换当前使用人
     * bluetoothDeviceId 设备id (string query required)
     * sort 排序 (string query required)
     * adminId 使用人 (integer query required)
     */
    post: (p, c) =>
      $.post("/api/bms/system/adminBluetoothRecord/changeUser", p, c),
  },
  adminBluetoothRecord_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/adminBluetoothRecord/list", p, c),
  },
  adminBluetoothRecord_listRecord: {
    /*
     * 使用记录列表
     * bluetoothDeviceId 设备id (string query required)
     * sort 排序 (string query required)
     */
    get: (p, c) =>
      $.get("/api/bms/system/adminBluetoothRecord/listRecord", p, c),
  },

  /**
   * 管理员
   */
  admin_updateSelf: {
    /*
     * 管理员自己修改信息，目前可修改工作手机和工作微信
     * nick 花名 (string query )
     * workPhone 工作手机 (string query )
     * workWechat 工作微信 (string query )
     * salesFirstPhone 话务外呼手机号1 (string query )
     * qwUserId 企微账号 (string query )
     * phoneSsid 手机热点标识 (string query )
     * defaultPlatform 默认平台 (string query )
     */
    put: (p, c) => $.put("/api/bms/system/admin/updateSelf", p, c),
  },
  admin_updatePassword: {
    /*
     * 修改密码
     * oldPassword 旧密码 (string query required)
     * password 新密码 (string query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/updatePassword", p, c),
  },
  admin_updateMyNick: {
    /*
     * 修改我的花名
     * nick 花名 (string query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/updateMyNick", p, c),
  },
  admin_updateClueReceiveStatus: {
    /*
     * 管理员修改线索接收状态
     * clueReceiveStatus 线索接收状态（正常|停止） (string query )
     */
    put: (p, c) => $.put("/api/bms/system/admin/updateClueReceiveStatus", p, c),
  },
  admin_resetPassword: {
    /*
     * 重置密码
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/resetPassword", p, c),
  },
  admin_handOver: {
    /*
     * 离职移交
     * type 类型：线索、审批节点、服务学生、负责合同 (string query required)
     * adminId 原负责人 (integer query required)
     * newAdminId 新负责人 (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/handOver", p, c),
  },
  admin_changeSubAdmin: {
    /*
     * 切换所负责管理员
     * adminId 管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/changeSubAdmin", p, c),
  },
  admin_changePlatform: {
    /*
     * 切换平台
     * platform 平台 (string query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/changePlatform", p, c),
  },
  admin_changeDepartment: {
    /*
     * 切换管理部门
     * departmentId 部门id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/changeDepartment", p, c),
  },
  admin_changeChargeSiteId: {
    /*
     * 切换负责院校
     * siteId 站点id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/changeChargeSiteId", p, c),
  },
  admin_changeAdmin: {
    /*
     * 切换管理员
     * adminId 管理员id (integer query required)
     */
    put: (p, c) => $.put("/api/bms/system/admin/changeAdmin", p, c),
  },
  admin: {
    /*
     * 添加
     * admin  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/admin", p, c),
  },
  admin_upload: {
    /*
     * 批量导入修改企微账号
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/system/admin/upload", p, c),
  },
  admin_signIn: {
    /*
     * 登录
     * appName 钉钉小程序名称 (string query )
     * phone 手机号 (string query )
     * password 密码 (string query )
     * pcCode PC免登码 (string query )
     * avatarCode PC点击头像免登码 (string query )
     * mPCode 小程序免登码 (string query )
     */
    post: (p, c) => $.post("/api/bms/system/admin/signIn", p, c),
  },
  admin_createTempPassword: {
    /*
     * 创建临时密码
     */
    post: (p, c) => $.post("/api/bms/system/admin/createTempPassword", p, c),
  },
  admin_authorizationHightRiskOperate: {
    /*
     * 高危操作认证
     * pcToken PC端token (string query required)
     */
    post: (p, c) =>
      $.post("/api/bms/system/admin/authorizationHightRiskOperate", p, c),
  },
  admin_searchMyNick: {
    /*
     * 查看我的花名
     */
    get: (p, c) => $.get("/api/bms/system/admin/searchMyNick", p, c),
  },
  admin_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/admin/list", p, c),
  },
  admin_listPosition: {
    /*
     * 职位列表
     * employStatus 是否内部员工 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/admin/listPosition", p, c),
  },
  admin_listDesensitizationAdmin: {
    /*
     * 可脱敏导出人员列表
     */
    get: (p, c) =>
      $.get("/api/bms/system/admin/listDesensitizationAdmin", p, c),
  },
  admin_listContainOther: {
    /*
     * 管理员列表(包含其他)
     * ableStatus 禁用启用 (string query )
     * position 职位 (string query )
     * positions 职位列表 (array query )
     * departmentId 部门 (integer query )
     * departmentIds 部门IDS (array query )
     */
    get: (p, c) => $.get("/api/bms/system/admin/listContainOther", p, c),
  },
  admin_listChargeAdmin: {
    /*
     * 所负责管理员列表
     * ableStatus 禁用启用 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/admin/listChargeAdmin", p, c),
  },
  admin_listByFirstGradeDepartment: {
    /*
     * 根据一级部门获取管理列表
     * department 一级部门名称 (string query required)
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) =>
      $.get("/api/bms/system/admin/listByFirstGradeDepartment", p, c),
  },
  admin_listAdmin: {
    /*
     * 管理员列表
     * ableStatus 禁用启用 (string query )
     * employStatus 职位 (string query )
     * position 职位 (string query )
     * positions 职位列表 (array query )
     * departmentId 部门 (integer query )
     * departmentIds 部门IDS (array query )
     */
    get: (p, c) => $.get("/api/bms/system/admin/listAdmin", p, c),
  },
  admin_listAdminByIds: {
    /*
     * 根据id获取管理员列表
     * ids 管理员id (array query required)
     */
    get: (p, c) => $.get("/api/bms/system/admin/listAdminByIds", p, c),
  },
  admin_isLeader: {
    /*
     * 判断是否是上级
     * adminId 管理员 (integer query required)
     * leaderId 上级 (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/admin/isLeader", p, c),
  },
  admin_getAdminInfo: {
    /*
     * 获取管理员编辑信息
     */
    get: (p, c) => $.get("/api/bms/system/admin/getAdminInfo", p, c),
  },
  admin_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/system/admin/export", p, c),
  },
  admin_downloadQwUserMould: {
    /*
     * 下载模版
     */
    get: (p, c) => $.get("/api/bms/system/admin/downloadQwUserMould", p, c),
  },
  admin_details: {
    /*
     * 详情
     * adminId 管理员id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/admin/details", p, c),
  },
  admin_checkLeaveInfo: {
    /*
     * 查看离职人员情况
     * adminId 管理员id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/admin/checkLeaveInfo", p, c),
  },
  admin_signOut: {
    /*
     * 退出
     */
    delete: (p, c) => $.delete("/api/bms/system/admin/signOut", p, c),
  },

  /**
   * 待办事项
   */
  toDoMatter: {
    /*
     * 添加
     * matter  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/toDoMatter", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/system/toDoMatter", p, c),
  },
  toDoMatter_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/toDoMatter/list", p, c),
  },
  toDoMatter_listLabel: {
    /*
     * 获取标签列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/toDoMatter/listLabel", p, c),
  },
  toDoMatter_listLabelByPostion: {
    /*
     * 根据登录管理员的角色获取标签列表
     * platform 平台 (string query required)
     */
    get: (p, c) => $.get("/api/bms/system/toDoMatter/listLabelByPostion", p, c),
  },
  toDoMatter_listByPosition: {
    /*
     * 根据登录管理员的角色获取待办事项列表
     * platform 平台 (string query )
     * label 标签 (string query )
     */
    get: (p, c) => $.get("/api/bms/system/toDoMatter/listByPosition", p, c),
  },

  /**
   * 临时管理员
   */
  temporaryAdmin: {
    /*
     * 添加
     * admin  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/temporaryAdmin", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/bms/system/temporaryAdmin", p, c),
  },
  temporaryAdmin_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/temporaryAdmin/list", p, c),
  },

  /**
   * 钉钉部门
   */
  dingDepartment_sync: {
    /*
     * 同步
     */
    post: (p, c) => $.post("/api/bms/system/dingDepartment/sync", p, c),
  },
  dingDepartment_listSimple: {
    /*
     * 根据登录管理员id获取列表
     */
    get: (p, c) => $.get("/api/bms/system/dingDepartment/listSimple", p, c),
  },
  dingDepartment_listIds: {
    /*
     * 根据管理员id获取列表
     * adminId 管理员id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/dingDepartment/listIds", p, c),
  },

  /**
   * 部门临时负责人
   */
  departmentTemporaryAdmin: {
    /*
     * 添加
     * departmentTemporaryAdmin  ( query required)
     */
    post: (p, c) => $.post("/api/bms/system/departmentTemporaryAdmin", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/bms/system/departmentTemporaryAdmin", p, c),
  },
  departmentTemporaryAdmin_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/departmentTemporaryAdmin/list", p, c),
  },

  /**
   * 考勤日期距离
   */
  attendanceDateDistance_sync: {
    /*
     * 同步
     */
    post: (p, c) => $.post("/api/bms/system/attendanceDateDistance/sync", p, c),
  },

  /**
   * 考勤日期
   */
  attendanceDate_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/bms/system/attendanceDate/upload", p, c),
  },
  attendanceDate_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/bms/system/attendanceDate/export", p, c),
  },

  /**
   * MCP 调用审计
   */
  mcpLog_listPage: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/bms/system/mcpLog/listPage", p, c),
  },
  mcpLog_formData: {
    /*
     * 表单数据
     * id 审计行 id (integer query required)
     */
    get: (p, c) => $.get("/api/bms/system/mcpLog/formData", p, c),
  },
};
